import Swal from 'sweetalert2';

console.log('sweetAlert.js utility loaded');

export const showSuccess = (title, text = '') => {
  return Swal.fire({
    icon: 'success',
    title,
    text,
    confirmButtonColor: '#D97706',
    customClass: {
      popup: 'font-sans',
      title: 'text-secondary',
      content: 'text-secondary'
    }
  });
};

export const showError = (title, text = '') => {
  return Swal.fire({
    icon: 'error',
    title,
    text,
    confirmButtonColor: '#D97706',
    customClass: {
      popup: 'font-sans',
      title: 'text-secondary',
      content: 'text-secondary'
    }
  });
};

export const showConfirm = (title, text = '', confirmText = 'Yes', cancelText = 'No') => {
  return Swal.fire({
    title,
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#D97706',
    cancelButtonColor: '#6B7280',
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      popup: 'font-sans',
      title: 'text-secondary',
      content: 'text-secondary'
    }
  });
};

export const showInfo = (title, text = '') => {
  return Swal.fire({
    icon: 'info',
    title,
    text,
    confirmButtonColor: '#D97706',
    customClass: {
      popup: 'font-sans',
      title: 'text-secondary',
      content: 'text-secondary'
    }
  });
};

export const showConfirmDelete = (text = "You won't be able to revert this!") => {
  return Swal.fire({
    title: 'Are you sure?',
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#c0544f',
    cancelButtonColor: '#7a746d',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    customClass: {
      popup: 'font-sans',
      title: 'text-secondary',
      content: 'text-secondary'
    }
  });
};

export const showToast = (title, icon = 'success') => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
    customClass: {
      popup: 'font-sans'
    }
  });

  return Toast.fire({
    icon,
    title
  });
};